import { ReactElement } from "react";
import { never } from "client_legacy/ndaw/errors";
import {
	GlobalSearchResultItemKind,
	IGlobalSearchResultItem,
	GlobalSearchScopeIdentifier
} from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { AnnouncementItemView } from "./AnnouncementItemView";
import { AppItemView } from "./AppItemView";
import { ContactItemView } from "./ContactItemView";
import { DocumentItemView } from "./DocumentItemView";
import { EmailItemView } from "./EmailItemView";
import { KnowledgeItemItemView } from "./KnowledgeItemsItemView";
import { EgnyteItemView } from "./EgnyteItemView";
import { EventItemView } from "./EventItemView";
import { TimeZone } from "client/DateAndTime/timezones";
import { IntegrationFlowItemView } from "./IntegrationFlowItemView";
import { CommunityItemView } from "./CommunityItemView";
import { CommunityPostItemView } from "./CommunityPostItemView";
import { ContactSource } from "client/Api/Email/contacts";

export type ItemViewProps = {
	itemIndex: number;
	item: IGlobalSearchResultItem;
	searchTerm: string;
	itemScope: GlobalSearchScopeIdentifier;
	isMobile: boolean;
	timezone: TimeZone;
	onOpenContactDetails: (id: string, source: ContactSource) => void;
	onDismiss: () => void;
	tabIndex: number;
};

export const ItemView = (props: ItemViewProps): ReactElement => {
	const {
		item,
		searchTerm,
		itemIndex,
		itemScope: itemsScope,
		isMobile,
		timezone,
		onOpenContactDetails,
		onDismiss,
		tabIndex
	} = props;

	switch (item.kind) {
		case GlobalSearchResultItemKind.App:
			return (
				<AppItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
					timezone={timezone}
				/>
			);
		case GlobalSearchResultItemKind.Contact:
			return (
				<ContactItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
					searchTerm={searchTerm}
					onOpenContactDetails={onOpenContactDetails}
				/>
			);
		case GlobalSearchResultItemKind.Document:
			return (
				<DocumentItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
					onDismiss={onDismiss}
					isMobile={isMobile}
					timezone={timezone}
				/>
			);
		case GlobalSearchResultItemKind.Email:
			return (
				<EmailItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
					timezone={timezone}
				/>
			);
		case GlobalSearchResultItemKind.Announcement:
			return (
				<AnnouncementItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
					timezone={timezone}
				/>
			);
		case GlobalSearchResultItemKind.KnowledgeItems:
			return (
				<KnowledgeItemItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
					timezone={timezone}
				/>
			);
		case GlobalSearchResultItemKind.EgnyteItem:
			return (
				<EgnyteItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
					onDismiss={onDismiss}
					isMobile={isMobile}
					timezone={timezone}
				/>
			);
		case GlobalSearchResultItemKind.Event:
			return (
				<EventItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
					timezone={timezone}
				/>
			);
		case GlobalSearchResultItemKind.IntegrationFlow:
			return (
				<IntegrationFlowItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
					timezone={timezone}
				/>
			);
		case GlobalSearchResultItemKind.Community:
			return (
				<CommunityItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
				/>
			);
		case GlobalSearchResultItemKind.CommunityPost:
			return (
				<CommunityPostItemView
					item={item}
					itemIndex={itemIndex}
					tabIndex={tabIndex}
					itemScope={itemsScope}
					timezone={timezone}
				/>
			);
		default:
			never(item);
	}
};

ItemView.displayName = "ItemView";